<template>
    <v-container fluid tag="section" class="mt-4 bg-white border rounded shadow">
        <div v-if="nivel_empleado<500"> 
            <v-row justify="center">
                <h3 class="text-center">{{ titulo_lista }}</h3><br>
                <h3 class="text-center">CUATRIMESTRE : {{ dato_cuatrimestre.no_cuatrimestre }} DEL AÑO {{ dato_cuatrimestre.anio }}</h3><br>
                <h4 class="text-center">FECHA INICIO EVALUACIÓN : {{ dato_cuatrimestre.fecha_inicio_captura }} FECHA FIN EVALUACIÓN {{ dato_cuatrimestre.fecha_fin_captura }}</h4><br>
            </v-row>
            <v-row justify="center">
                <v-alert class="text-center" type="success" icon="mdi-alert-circle-outline">
                    <ul style="list-style-type: disc; padding-left: 20px; text-align: justify;">
                    
                            En este módulo usted podrá dar seguimiento al proceso de evaluación del cuatrimeste activo o consultar información de cuatrimestres que ya han sido concluidos. 
                            <br><br>
                            Para visualizar la información debe seleccionar el año del cuatrimestre que desea consultar y despues seleccionar el periodo. Después de haber seleccionado los filtros anteriores se le desplegará la lista de los evaluadores que pertenecen a su unidad administrativa y podrá revisar el avance de cada uno de ellos. 
                            <br><br>
                            También podrá realizar la evaluación de los empleados asigandos a sus jefes de departamento si así lo desea. Esto lo podrá realizar seleccionando la opción “Ver evaluados”  y a continuación se le desplegará la lista de empleados asignados a el jefe de departamento y podrá seleccionar la opción de evaluar. Cuando se despliegue el formulario de evaluación usted podrá guardar o enviar el formulario. La opción “Guardar” es para que pueda modificar la evaluación en otro momento y la opción “Enviar” ya no le permitirá hacer modificaciones. 
                            <br><br>
                            Cuando todos los empleados hayan sido evaluados se activará un botón para “TERMINAR PROCESO” y eso le permitirá generar los acuses correspondientes.
                        
                    </ul>
                </v-alert>
            </v-row>
            <v-row v-if="mostrar_tabla_evaluadores">
                <v-col class="d-flex" cols="4" sm="4">
                    <v-select 
                        color="blue-grey lighten-4" 
                        solo 
                        item-color="blue-grey lighten-4" 
                        :menu-props="{ top: true, offsetY: false }" 
                        v-model="year" 
                        :items="years" 
                        item-text="anio"
                        item-value="anio" 
                        label="Año" 
                        @change="load_cuatrimestres_by_year">
                    </v-select>
                </v-col>
                <v-col class="d-flex" cols="6" sm="4">
                    <v-select 
                        color="blue-grey lighten-4" 
                        solo 
                        item-color="blue-grey lighten-4" 
                        :menu-props="{ top: true, offsetY: false }" 
                        v-model="cuatrimestre_id" 
                        :items="cuatrimestres" 
                        item-text="meses"
                        item-value="id" 
                        label="Cuatrimestre" 
                        @change="load_evaluadores_ur_cuatrimestre_user">
                    </v-select>
                </v-col>
            </v-row>

            <v-row v-if="mostrar_tabla_evaluadores && showTableEvaluadores">  
                <v-col class="d-flex" cols="12" sm="4" > 
                    <div v-if="total_a_evaluar_global !=total_enviados_global">
                        <v-btn   small color="#e70c0e" @click="terminar_proceso_enviado()" v-if="(total_a_evaluar_global == (total_enviados_global+total_guardado_global))">
                            <v-icon>fa fa-file-pdf-o</v-icon> <span> TERMINAR PROCESO</span>
                        </v-btn> 
                    </div>
                    

                    <v-btn   small color="#e70c0e" @click="generarAcuseUr()" v-if="total_a_evaluar_global == total_enviados_global">
                        <v-icon>fa fa-file-pdf-o</v-icon> <span> DESCARGAR ACUSE</span>
                    </v-btn> 

                    <v-btn   small color="#e70c0e" @click="generarReporteDiasEconomicos()" v-if="(total_a_evaluar_global == total_enviados_global) && dato_cuatrimestre.estatus == 0">
                        <v-icon>fa fa-file-pdf-o</v-icon> <span> REPORTE DÍAS EXTRAORDINARIOS</span>
                    </v-btn> 

                </v-col> 
                <v-col cols="12" sm="12">
                    <v-client-table :data="evaluadores_ur" :columns="columnsEvaluadores" :options="optionsEvaluadores">
                        <template slot="acciones" slot-scope="empleado">
                            <a type="button" @click="cambiar_vista_a_evaluados(empleado.row)" class="dropdown-item" title="VER INFORMACIÓN DEL EMPLEADO">
                                <i class="text-success fa fa-eye"></i>
                                <span>Ver evaluados</span>
                            </a>
                        </template> 
                    </v-client-table>
                </v-col>
            </v-row>
            <v-row justify="center">
                <v-row v-if="mostrar_tabla_empleado && !mostrar_tabla_evaluadores">
                    <v-col class="text-right" cols="12">
                    <v-btn @click="regresar_vista_evaluadores();" class="ma-2" color="primary">Regresar</v-btn>
                    </v-col>
                </v-row>
                
                
                <v-row v-if="mostrar_tabla_empleado && !mostrar_tabla_evaluadores">
                    <!--  -->
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <!-- <th style="font-weight: bold;" COLSPAN="4" class="text-center"> <h3>TOTAL INGRESOS {{ anio }}</h3>  </th> -->
                                </tr>
                                <tr>
                                    <th class="text-center" style="font-weight: bold;">
                                        <h3>Total a evaluar</h3>
                                    </th>
                                    <th class="text-center" style="font-weight: bold;">
                                        <h3>Total enviados</h3>
                                    </th>
                                    <th class="text-center" style="font-weight: bold;">
                                        <h3>Total guardados</h3>
                                    </th>

                                    <th class="text-center" style="font-weight: bold;">
                                        <h3>Por evaluar</h3>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td class="text-center" style="font-weight: bold;" >
                                        <h3>{{informacion_evaluacion.total_a_evaluar}}</h3> 
                                    </td>

                                    <td class="text-center" style="font-weight: bold;" >
                                        <h3>{{informacion_evaluacion.total_enviados}}</h3> 
                                    </td>

                                    <td class="text-center" style="font-weight: bold;" >
                                        <h3>{{informacion_evaluacion.total_guardados}}</h3> 
                                    </td>

                                    <td class="text-center" style="font-weight: bold;" >
                                        <h3>{{informacion_evaluacion.restantes}}</h3> 
                                    </td>
                                    
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <!--  -->
                </v-row>
                <br>
                <!--  -->
                <v-row justify="center" v-if="mostrar_tabla_empleado && !mostrar_tabla_evaluadores"> 
                    <v-col class="d-flex" cols="12" sm="4">
                        <label>ESTADO EVALUACIÓN</label><br>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="4">
                        <label>ÁREA</label><br>
                    </v-col>
                </v-row>
                <!--  -->
                <v-row justify="center" v-if="mostrar_tabla_empleado && !mostrar_tabla_evaluadores"> 
                    <v-col class="d-flex" cols="12" sm="4"> 
                        <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="tipo_filtro" :items="tipos_filtro" item-text="descripcion"
                            item-value="id" label="ESTADO EVALUACIÓN" @change="load_empleados_a_evaluar">
                        </v-select>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="4">
                        <v-select color="blue-grey lighten-4" solo item-color="blue-grey lighten-4" :menu-props="{ top: true, offsetY: false }" v-model="id_estructura_organizacional" :items="areas_array" item-text="nombre"
                            item-value="id" label="ÁREA" @change="load_empleados_a_evaluar">
                        </v-select>
                    </v-col>
                    <v-col class="d-flex" cols="12" sm="4" v-if="informacion_evaluacion.total_a_evaluar==informacion_evaluacion.total_enviados">
                        <v-btn   small color="#e70c0e" @click="generarAcuse()">
                            <v-icon>fa fa-file-pdf-o</v-icon> <span> DESCARGAR ACUSE</span>
                        </v-btn> 
                    </v-col> 
                    
                </v-row>
                <!--  -->
                
                <!--  -->
                <v-row v-if="mostrar_tabla_empleado && !mostrar_tabla_evaluadores"> 
                    <v-col v-if="showTable" cols="12" sm="12">
                        <v-client-table :data="empleados_a_evaluar" :columns="columns" :options="options">
                            <template slot="acciones" slot-scope="empleado">
                                <a type="button" @click="cambiar_vista_formulario(empleado.row)" class="dropdown-item" title="VER INFORMACIÓN DEL EMPLEADO">
                                    <i class="text-success fa fa-eye"></i>
                                    <span>Evaluar</span>
                                </a>
                            </template>
                            <template slot="estado_evaluacion" slot-scope="empleado">
                                <span v-if="empleado.row.estado_evaluacion =='GUARDADO' || empleado.row.estado_evaluacion =='ENVIADO'" class="text-success">
                                    {{ empleado.row.estado_evaluacion }}
                                </span>
                                <span v-else class="text-success">NO EVALUADO</span>

                            </template>
                        </v-client-table>
                    </v-col>
                </v-row>
                <div v-if="!mostrar_tabla_empleado && !mostrar_tabla_evaluadores">
                    <v-container>
                        <v-row>
                            <v-col class="text-right" cols="12">
                            <v-btn @click="funcion_regresar();" class="ma-2" color="primary">Regresar</v-btn>
                            </v-col>
                        </v-row>
                        <v-form>
                            <u >
                                <FONT SIZE=5 style="text-align: center;">CEDULA DE EVALUACIÓN DEL DESEMPEÑO LABORAL</FONT>
                            </u>
                            <br>
                            <!--  -->
                            <h2>OBJETIVO</h2>
                            <P>
                                Valorar las características del personal a fin de detectar a los trabajadores que se distinguen en el desempeño de sus funciones y considerar los beneficios que se les puedan brindar de acuer al programa de estimulos y recompensas.
                            </P>

                            <!--  -->
                            <h2>INSTRUCCIONES</h2>
                            <p>
                                La calificación se realizará con la mayor objetividad e imparcialidad posible, en la inteligencia de que su manejo será de carácter confidencial.
                            </p>
                            <!--  -->
                            <p>
                                Al reverso de esta hoja encontrará una serie de factores que intervienen en el Desempeño Laboral del personal y cada uno de ellos tiene diferentes conceptos que deberán ser calificados individualmente.
                            </p>
                            <!--  -->
                            <p>
                                Se deberá analizar cada concepto y marcar la calificación de éste con una <strong> "X" </strong> en el cuadro respectivo. No marque más de una calificación por concepto o de lo contrario será anulada.
                            </p>
                            <!--  -->
                            <p>
                                No deberá hacer ninguna anotación en la columna de <strong> "PUNTOS" </strong> ni en los cuadros marcados con un <strong> "*" </strong>, Asterisco. Son para uso exclusivo de la Dirección Administrativa.
                            </p>
                            <!--  -->
                            <h2>DATOS DEL EVALUADO</h2>
                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="datos_evaluado.nombre_completo" label="NOMBRES" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="datos_evaluado.puesto" label="PUESTO" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="datos_evaluado.dependencia" label="DEPENDENCIA" required></v-text-field>
                                </v-col>
                            </v-row>

                            <v-row>
                                <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="datos_evaluado.unidad_responsable" label="DIRECCIÓN" required></v-text-field>
                                </v-col>
                                <!-- <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="datos_evaluado.rfc" label="RFC" required></v-text-field>
                                </v-col> -->
                                <v-col cols="12" md="4">
                                    <v-text-field disabled v-model="datos_evaluado.nivel" label="NIVEL" required></v-text-field>
                                </v-col>
                            </v-row>
                            <!--  -->
                            <h2>DATOS DEL EVALUADOR</h2>
                            <v-row>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="datos_evaluador.nombre_completo" label="NOMBRES" required></v-text-field>
                                </v-col>
                                <v-col cols="12" md="6">
                                    <v-text-field disabled v-model="datos_evaluador.puesto_trabajador" label="PUESTO" required></v-text-field>
                                </v-col>
                            </v-row>
                            <!--  -->
                            <br> <h3 class="text-center">CÉDULA DE EVALUACIÓN</h3><br>
                            <h3 class="text-center">{{ grupo_puesto_eval }}</h3><br>

                            <v-container v-for="item in datos_preguntas" :key="item.id">
                                <h3 class="text-center">{{ item.descripcion }}</h3><br>
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th style="width: 75%; text-align: left;"></th>
                                                <th v-for="item_valores in item.valores_evaluacion" :key="item_valores.id" style="width: 5%; text-align: left;">
                                                    {{ item_valores.descripcion }}
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item_preguntas in item.preguntas" :key="item_preguntas.id" >
                                            <td>{{ item_preguntas.descripcion }}</td>

                                            <td v-for="item_valores_preguntas in item_preguntas.valores_evaluacion" :key="item_valores_preguntas.id" >
                                                <v-checkbox :disabled ='!editar' v-model="item_valores_preguntas.selected" @click="handleCheckboxChange(item_valores_preguntas, item_preguntas.valores_evaluacion)">
                                                </v-checkbox>
                                            </td>

                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-container>

                            <v-row justify="center" v-if="editar">
                                <v-col cols="12" md="auto" v-if="datos_preguntas.length >0">
                                    <v-btn color="primary" @click="guardar_formulario_empleado('enviar')">Enviar</v-btn>
                                </v-col>
                                <v-col cols="12" md="auto" v-if="datos_preguntas.length >0">
                                    <v-btn color="primary" @click="guardar_formulario_empleado('guardar')">Guardar</v-btn>
                                </v-col>
                            </v-row>
                            <v-row justify="center" v-else>
                                <v-col cols="12" md="auto">
                                    <v-alert type="success" icon="mdi-alert-circle-outline">
                                        Este formulario ha sido enviado!!!
                                    </v-alert>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-container>
                </div>
            </v-row>
            <!-- Incluye el componente ModalEspera -->
            <ModalEspera ref="modalEspera"/>
        </div>
        <div v-else>
            
            <AccessDenied v-if="es_evaluador =='no_es_evaluador'" />
        </div>
           
    </v-container>

</template>
<style>
    .grupo-botones {
      display: none;
      margin-top: 10px;
    }

    .boton {
      padding: 10px 20px;
      margin-right: 5px;
    }

  </style>
<script>
import { mapState } from 'vuex'
import ModalEspera from "./ModalWait.vue";
import AccessDenied from "./AccessDenied.vue";

export default {
    components: {
        ModalEspera,
        AccessDenied
    },
    data:function(){
        return {
            showTable:false,
            showAlert:false,
            showTableLiquidados:false,
            showAlertLiquidados:false,

            mostrar_tabla_evaluadores : true, 
            showTableEvaluadores      : false,
            showTableEvaluadores:false,
            showAlertEvaluadores:false,
             // datos tabla evaluadores
             evaluadores_ur : [],
             columnsEvaluadores: ["no_empleado",'nivel',"ap_paterno","ap_materno", "nombre","area",'total_evaluar','total_enviados','total_guardados','por_evaluar','acciones'],
             optionsEvaluadores: {
                headings: {
                    no_empleado       : '# EMPLEADO',
                    nivel             : 'NIVEL',
                    ap_paterno        : "APELLIDO PATERNO",
                    ap_materno        : "APELLIDO MATERNO",
                    nombre            : "NOMBRE",
                    area              : "ÁREA", 
                    total_evaluar     : 'TOTAL A EVALUAR',
                    total_enviados    : 'TOTAL ENVIADOS',
                    total_guardados   : 'TOTAL GUARDADOS',
                    por_evaluar       : 'POR EVALUAR',
                    acciones          : 'ACCIONES',

                },
                sortable: ['no_empleado'],
                texts: {
                    count:"",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['no_empleado','nivel',"ap_paterno","ap_materno", "nombre","area"],
                    templates: {

                    }, filterByColumn: true,
            },
            //
            // datos tabla
            columns: ["no_empleado",'nivel',"ap_paterno","ap_materno", "nombre","area",'nombre_evaluador','estado_evaluacion','acciones'],
             options: {
                headings: {
                    no_empleado       : '# EMPLEADO',
                    nivel             : 'NIVEL',
                    ap_paterno        : "APELLIDO PATERNO",
                    ap_materno        : "APELLIDO MATERNO",
                    nombre            : "NOMBRE",
                    area              : "ÁREA",
                    nombre_evaluador  : "EVALUADOR", 
                    estado_evaluacion : 'ESTADO DE EVALUACIÓN',
                    acciones          : 'ACCIONES',

                },
                sortable: ['no_empleado'],
                texts: {
                    count:"",
                    filter:"Buscar:",
                    filterPlaceholder: 'Buscar...',
                    limit:"Resultados:",
                    recordsDisplay: 'Resultados',
                    page:"Página:",
                    noResults:"No hay resultados",
                    filterBy: 'Buscar...',
                    loading:'Cargando...',
                    defaultOption: 'Seleccionar {column}'
                },
                filterable: true,
                filterByColumn: false,
                resizableColumns: false,
                sendEmptyFilters :false,
                childRowTogglerFirst: true,
                showChildRowToggler: true,
                perPage: 5,
                perPageValues: [5, 10, 15, 20],
                filterable: ['no_empleado','nivel',"ap_paterno","ap_materno", "nombre","area"],
                    templates: {

                    }, filterByColumn: true,
            },
            mostrarModal: false,
            //variables
            empleados_a_evaluar    : [],
            liquidados             : [],
            mostrar_tabla_empleado : false,
            apellidoPaterno        : '',
            apellidoMaterno        : '',
            nombre                 : '',
            rfc                    : '',
            grupoPuesto            : '',
            datos_evaluador        : [],
            datos_evaluado         : [],
            datos_preguntas        : [],
            grupo_puesto_eval      : '',
            registro_evaluacion    : [],
            editar                 : true,
            dato_cuatrimestre      : [],
            areas : [],
            id_estructura_organizacional : 0,
            areas_array : [],
            tipos_filtro : [{id:0,descripcion:'TODOS'},{id:1,descripcion:'NO EVALUADOS'},{id:2,descripcion:'GUARDADOS'},{id:3,descripcion:'ENVIADOS'}],
            tipo_filtro : 0,
            informacion_evaluacion : [],
            datos_user_sesion : null,
            nivel_empleado : null,
            titulo_lista : 'LISTA DE EVALUADORES',
            total_a_evaluar_global : 0,
            total_enviados_global : 0,
            total_guardado_global : 0,
            total_por_evaluar_global : 0,
            years: [],
            year: null,
            cuatrimestres: [],
            cuatrimestre_id: null

        }
    },
    computed:{
        ...mapState(["user"]),
        ...mapState(["token"]),
        ...mapState(["baseUrl"])
    },
    async mounted(){
        this.datos_user_sesion = JSON.parse(localStorage.getItem('user'));
        this.nivel_empleado = parseInt(this.datos_user_sesion.nivel, 10); 
        await this.load_years_cuatrimestre();
        this.$NProgress.done();
        
    },
    methods:{
        async load_years_cuatrimestre(){
            try {
                let response = await this.$http.get("get-years-cuatrimestres");

                this.years = response.data.data;
                
            } catch (error) {
                console.log(error); 
            }

        },
        async load_cuatrimestres_by_year(){
            
            try {

                this.cuatrimestre_id = null;

                this.showTableEvaluadores = false;

                this.dato_cuatrimestre = [];

                let response = await this.$http.get("get-cuatrimestres-by-year/"+this.year);

                this.cuatrimestres = response.data.data;
                
            } catch (error) {
                console.log(error); 
            }

        },
        async load_evaluadores_ur_cuatrimestre_user(){
            try{
                
                let response = await this.$http.get("get-evaluadores-cuatrimestre-ur/"+this.datos_user_sesion.id_empleado+"/"+this.cuatrimestre_id);

                this.evaluadores_ur = response.data.data.activos;
                this.dato_cuatrimestre   = response.data.data.dato_cuatrimestre;
                this.total_a_evaluar_global = response.data.data.total_a_evaluar_global;
                this.total_enviados_global   = response.data.data.total_enviados_global;
                this.total_guardado_global = response.data.data.total_guardado_global;
                this.total_por_evaluar_global = response.data.data.total_por_evaluar_global
                if (this.evaluadores_ur){
                    this.showTableEvaluadores = true;
                }else{
                    this.showAlertEvaluadores = true
                }


            }catch(error){
                this.showAlertEvaluadores = true;
            }
        },

        async load_empleados_a_evaluar(){
            try{
                
                let response = await this.$http.get("get-empleados-cuatrimestre-a-evaluar/"+this.datos_evaluador.evaluador_id+'/'+this.tipo_filtro+'/'+this.id_estructura_organizacional+'/'+this.cuatrimestre_id);

                this.empleados_a_evaluar = response.data.data.activos;
                if (this.empleados_a_evaluar){
                    this.showTable = true;
                }else{
                    this.showAlert = true
                }


            }catch(error){
                this.showAlert = true;
            }
        },
        cambiar_vista_formulario :function(empleado){
            this.datos_preguntas = [];
            this.registro_evaluacion = []
            this.datos_evaluado = empleado;
            this.grupo_puesto_eval = 'GRUPO '+empleado.grupo_puesto
            this.obtener_formularios_empleado();
            setTimeout(() => {
                this.mostrar_tabla_empleado = false

            }, 1000);


        },
        funcion_regresar:function(){
            this.mostrar_tabla_empleado = true;
        },

        async obtener_formularios_empleado(){
            try{
                this.editar = true;
                let response = await this.$http.get("get-formulario-cuatrimestre-empleado/"+this.datos_evaluado.grupo_puestos_id+'/'+this.datos_evaluado.id_empleado+'/'+this.datos_evaluado.cuatrimestre_id+'/'+this.datos_evaluador.evaluador_id);

                this.datos_preguntas = response.data.data.activos;
                this.registro_evaluacion = response.data.data.registro_evaluacion;

                if(this.registro_evaluacion){
                    if(this.registro_evaluacion.estados_evaluacion_id == 2){
                        this.editar =false;
                    }
                }


            }catch(error){

            }
        },

        handleCheckboxChange(item_valores,grupo_de_valores) {

            grupo_de_valores.forEach(objeto => {
                if (item_valores.id !== objeto.id) {
                    // Duplica el objeto para evitar compartir referencias
                    objeto.selected = false;
                }
            });
             return grupo_de_valores
        },

        guardar_formulario_empleado:async function(tipo_guardado){

            try{
                var mensaje = '¿Estas seguro de guardar la evaluación?'
                var mensaje_advertencia = ''
                if(tipo_guardado =='enviar'){
                    mensaje = '¿Estas seguro de enviar la evaluación?'
                    mensaje_advertencia = 'una vez enviado no se podra editar la evaluación'
                }
                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                         var tipo_usuario = "ADMINISTRADOR"
                        form.append("tipo_guardado",tipo_guardado);
                        form.append("datos_evaluado",JSON.stringify(this.datos_evaluado));
                        form.append("datos_preguntas",JSON.stringify(this.datos_preguntas));
                        form.append("evaluador_id",this.datos_evaluador.evaluador_id);
                        form.append("id_user",this.datos_user_sesion.id_user);
                        form.append("tipo_usuario",tipo_usuario);

                        
                        let response = await this.$http.post("guardar-formulario-cuatrimestre",form);
                        if(response.data.response){
                            this.$refs.modalEspera.mostrarModal = false;
                            await this.load_empleados_a_evaluar();
                            await this.load_datos_cuatrimestre_evaluacion();
                            this.funcion_regresar();
                            this.$toastr.success('EL FORMULARIO SE HA GUARDADO EXITOSAMENTE!!');
                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                console.log(error)
            }
        },

        async load_datos_cuatrimestre_evaluacion(){
            try{ 
                let response = await this.$http.get("obtener-datos-generales-evaluacion/"+this.datos_evaluador.evaluador_id+'/'+this.dato_cuatrimestre.id);

                this.informacion_evaluacion = response.data.data;
                 
            }catch(error){
                this.showAlert = true;
            }
        },

        async load_areas_empleados(){
            try{

                let response = await this.$http.get("get-areas-empleados-cuatrimestre-a-evaluar/"+this.datos_evaluador.evaluador_id+"/"+this.cuatrimestre_id);

                this.areas_array = response.data.data.activos;
                 


            }catch(error){
                this.showAlert = true;
            }
        },

        generarAcuse:function(){
             
            window.open(this.baseUrl + "cuatrimestre/descargar-acuse?evaluador_id="+this.datos_evaluador.evaluador_id+"&cuatrimestre_id="+this.dato_cuatrimestre.id+"&id_user="+this.datos_user_sesion.id_user,"_blank");
        },

        generarAcuseUr:function(){
             
             window.open(this.baseUrl + "cuatrimestre/descargar-acuse-ur?id_empleado="+this.datos_user_sesion.id_empleado+"&cuatrimestre_id="+this.dato_cuatrimestre.id+"&id_user="+this.datos_user_sesion.id_user,"_blank");
        },

        cambiar_vista_a_evaluados : async function(datos_evaluador){
            this.datos_evaluador = datos_evaluador
            this.titulo_lista = 'LISTA DE EMPLEADOS'
            this.mostrar_tabla_empleado = true
            this.mostrar_tabla_evaluadores = false
            this.id_estructura_organizacional = 0
            this.tipo_filtro = 0
            await this.load_empleados_a_evaluar();
            await this.load_datos_cuatrimestre_evaluacion();
            await this.load_areas_empleados()
           
        },

        regresar_vista_evaluadores : async function(){
            this.titulo_lista = 'LISTA DE EVALUADORES'
            this.mostrar_tabla_evaluadores = true
            this.mostrar_tabla_empleado = false
            await this.load_evaluadores_ur_cuatrimestre_user(); 
        },

        terminar_proceso_enviado : function(){
            try{
                var mensaje = '¿Estas seguro de iniciar el proceso de enviado?'
                var mensaje_advertencia = ''
                
                this.$swal({
                    className: "text-center",
                    title: mensaje,
                    text: mensaje_advertencia,
                    icon: "warning",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    reverseButtons: true,
                    buttons:["Cancelar","Aceptar"],
                    }).then(async (value) => {
                        if(value){
                        this.$refs.modalEspera.mostrarModal = true;
                        let form = new FormData();
                        // form.append("tipo_nomina",this.tipoNomina);
                        form.append("id_empleado",this.datos_user_sesion.id_empleado); 
                        form.append("cuatrimestre_id",this.dato_cuatrimestre.id);
                        form.append("id_user",this.datos_user_sesion.id_user);

                        let response = await this.$http.post("empleados-evaluados-actualizar-a-enviado",form);
                        if(response.data.response){
                            this.$refs.modalEspera.mostrarModal = false;
                            await this.load_evaluadores_ur_cuatrimestre_user(); 
                            this.$toastr.success('SE HA ACTUALIZADO LAS EVALUACIÓNES A ESTATUS ENVIADO!!');
                        }else{
                            this.$refs.modalEspera.mostrarModal = false;
                            this.$swal({
                                title: response.data.error,
                                text: "",
                                icon: "error",
                                button:"Aceptar"
                            }).then(() => this.dialog = true);


                        }
                    }
                });
            }catch(error){
                this.$refs.modalEspera.mostrarModal = false;
                console.log(error)
            }
        },

        generarReporteDiasEconomicos:function(){
             var tipo_reporte = "ADMINISTRADOR"
             
             window.open(this.baseUrl + "cuatrimestre/reporte-dias-economicos-admin-zip?id_empleado="+this.datos_user_sesion.id_empleado+"&cuatrimestre_id="+this.dato_cuatrimestre.id+"&tipo_reporte="+tipo_reporte+"&id_user="+this.datos_user_sesion.id_user+"&rfc="+this.datos_user_sesion.rfc,"_blank");
        },
         


    }
}
</script>
